import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "lead text-muted" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Log ID:", -1)
const _hoisted_4 = { class: "lead text-muted" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Context:", -1)
const _hoisted_6 = { class: "flex flex-column w-full gap-3 surface-border" }
const _hoisted_7 = { class: "lead text-muted m-0" }

import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { showErrorModal, errorContent, closeErrorModal } from '@/composables/useErrorLog';

declare const navigator: Navigator & {
  clipboard?: {
    writeText(text: string): Promise<void>;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  setup(__props) {

const toast = useToast();
const error = computed(() => { return JSON.parse(errorContent.value) });

const copyLogID = async () => {
    try {
        if (navigator.clipboard) {
            await navigator.clipboard.writeText(error.value.logID);
            return toast.add({ severity: 'success', summary: `Clipboard`, detail: 'Copied to clipboard.', life: 1000 });
        }
    } catch (error) {
        return toast.add({ severity: 'error', summary: `Clipboard`, detail: 'Failed copying Log ID.', life: 1000 });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_component_Dialog, {
      class: "profile",
      visible: _unref(showErrorModal),
      "onUpdate:visible": [
        _cache[0] || (_cache[0] = ($event: any) => (_isRef(showErrorModal) ? (showErrorModal).value = $event : null)),
        _unref(closeErrorModal)
      ],
      modal: "",
      header: "Error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(error.value.logID) + " ", 1),
            _createElementVNode("i", {
              class: "pi pi-copy",
              style: {"cursor":"pointer"},
              onClick: copyLogID
            })
          ]),
          _createElementVNode("p", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(error.value.context), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(error.value.message), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ], 64))
}
}

})